module.exports = __webpack_public_path__ + "02_bob_yellow.04e42f19.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/02_bob_yellow.png
// module id = bUq2
// module chunks = 0